export default __webpack_public_path__ + "resources/icons/n310-9355.png";